// src/utils/cn.ts
import { twMerge } from "tailwind-merge";
var cn = twMerge;

export {
  cn
};
